module.exports = __webpack_public_path__ + "media/img/chat-5784b35debb1640462291db585082177.svg";